<template>
  <div v-if="getGraphCharts">
    <div v-if="currentSubType.key === RESOURCE" class="mongo-label">
      {{ getLabels[0].label }}
    </div>
    <div class="mongo-graph-container">
      <div
        class="mongo-chart-element"
        v-for="(chartConfig, index) in getGraphCharts[0]"
        :key="index + chartConfig.metricName"
        :style="{ width: chartConfig.width }"
      >
        <GraphBuilder
          :chartConfig="chartConfig"
          :index="index"
          :layoutIndex="0"
        />
      </div>
    </div>
    <div class="graph-partition" v-if="currentSubType.key === RESOURCE">
      <div class="partition-label">
        {{ getLabels[1].label }}
      </div>
      <div class="mongo-graph-line-separator"></div>
    </div>
    <div class="mongo-graph-container">
      <div
        class="mongo-chart-element"
        v-for="(chartConfig, index) in getGraphCharts[1]"
        :key="index + chartConfig.metricName"
        :style="{ width: chartConfig.width }"
      >
        <GraphBuilder
          :chartConfig="chartConfig"
          :index="index"
          :layoutIndex="1"
        />
      </div>
    </div>
  </div>
</template>
<script>
import GraphBuilder from '@/components/Common/GraphBuilder.vue';
import { mapState, mapGetters } from 'vuex';
import {
  graphLabels,
  DatabaseTypes,
} from '@/components/Database/database.types';
import { SUB_TYPES } from '@/utils/templates/databaseTemplate/database.constants';
import databaseCharts from '@/utils/templates/database.charts.template';

export default {
  components: {
    GraphBuilder,
  },
  data() {
    return {
      RESOURCE: SUB_TYPES.MONGO_RESOURCE,
    };
  },
  computed: {
    ...mapState('globalState/app', ['chartsTemplate']),
    ...mapState('databaseState/databaseCommonState', [
      'currentDatabaseType',
      'currentDatabaseService',
    ]),
    ...mapState('databaseState/detail', [
      'currentDatabaseInstance',
      'currentSubType',
    ]),
    ...mapGetters('databaseState/databaseCommonState', ['getCurrentDatabase']),

    getChartsTemplate() {
      if (
        this.currentSubType?.key &&
        this.currentDatabaseType?.key === DatabaseTypes.mg
      )
        return this.chartsTemplate[this.currentDatabaseType?.key][
          this.currentSubType?.key
        ];
      else return {};
    },
    getGraphCharts() {
      return this.currentDatabaseType?.key === DatabaseTypes.mg
        ? databaseCharts()[this.currentDatabaseType?.key]?.[
            this.currentSubType?.key
          ]?.graphs?.template
        : {};
    },
    getLabels() {
      return graphLabels()[this.currentSubType?.key] ?? null;
    },
  },
};
</script>
<style lang="scss" scoped>
.mongo-chart-element {
  margin-bottom: 1.5em;
  margin-right: 1.5em;
  margin-top: 0.125em;
}

.mongo-graph-container {
  width: 100%;
  @include flex-center-justify(space-between);
  flex-wrap: wrap;
  margin-top: 1.438em;
}
.graph-partition {
  @include flex-center;
  margin-top: 1.4em;
}
.mongo-label {
  font-family: 'RakutenSansUI-SemiBold';
  text-align: left;
  color: $color-white;
}
.partition-label {
  margin-right: 0.5rem;
  font-family: 'RakutenSansUI-SemiBold';
}
.mongo-graph-line-separator {
  border: 0.03125em solid $color-white;
  opacity: 0.6;
  flex: 1;
}
</style>
